import { Button } from "antd";
import { Link } from "react-router-dom";
import { chatUserPath } from "../../routes/routes";
import { useMediaQuery } from "react-responsive";

export const ConnectedUser = ({
  userData,
  connectedUser,
  profPic,
  texts,
  canSendMessage = true,
  label,
}) => {
  const isMobile = useMediaQuery({maxWidth: 1024})

  if (!canSendMessage) {
    return null;
  }

  return (
    <>
      <div style={{ marginRight: "1vw" }}>
        <Link to={chatUserPath} state={{ ...connectedUser, profPic }}>
          <Button
            style={{
              background: "#f18b6f",
              borderColor: "#f18b6f",
              color: "white",
              padding: "12px 10px",
              fontSize: isMobile ? "12px": "16px",
              fontWeight: "bold",
              borderRadius: "999px",
              minWidth: "10px",
            }}
          >
            {label || texts?.LB0134}
          </Button>
        </Link>
      </div>
    </>
  );
};
